import cn from 'clsx';
import React from 'react';

import { NotificationIcon } from 'components/NotificationIcon';
import { TSubscribedFilter } from 'store/Subscriptions/SubscribedFilter';

import css from './Notification.module.css';

interface INotification {
  filter: TSubscribedFilter;
}

const Notification = ({ filter }: INotification) => {
  if (!filter.notifications?.length) return null;

  const notification = filter.notifications[0];

  const handleNotificationClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  if (filter.notifications.length > 1 && filter.instance) {
    const { summaryNotification } = filter.instance;

    return (
      <span className={css.notification} onClick={handleNotificationClick}>
        <span className={cn(css.description, css[summaryNotification.level])}>
          <NotificationIcon notification={summaryNotification} />
          {summaryNotification.description}
        </span>
      </span>
    );
  }

  return (
    <span className={cn(css.notification)} onClick={handleNotificationClick}>
      <span className={cn(css.description, css[notification.level])}>
        <NotificationIcon notification={notification} />
        {notification.description}
      </span>
      {notification.link && (
        <a
          className={cn(css.link, 'glz-link glz-is-small glz-is-underline')}
          href={notification.link?.url}
          rel="noreferrer"
          target="_blank"
        >
          {notification.link?.text}
        </a>
      )}
    </span>
  );
};

export { Notification };
